import {
  currencyShort,
  formatNumber,
  retainCaretPositionForCurrencyAndNumbers
} from "@wrstudios/utils";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Input from "../../common/Input";
import Label from "../../common/Label";
import StreamFilter from "./StreamFilter";
import { Cell, Grid, Spacer } from "./styled/stream-filter-price";
import { buildMinMaxLabel } from "./utils";

class StreamFilterPrice extends Component {
  state = {
    min: null,
    max: null
  };

  static getDerivedStateFromProps(props, state) {
    return {
      min:
        state.min === null &&
        typeof props.min !== "undefined" &&
        props.min !== "0"
          ? props.min
          : state.min,
      max:
        state.max === null &&
        typeof props.max !== "undefined" &&
        props.max !== "0"
          ? props.max
          : state.max
    };
  }

  render() {
    const label = buildMinMaxLabel(
      currencyShort(this.props.min),
      currencyShort(this.props.max)
    );

    let minValue = formatNumber(this.state.min, "$0,0");
    if (minValue === "$0" || minValue === "$") minValue = "";

    let maxValue = formatNumber(this.state.max, "$0,0");
    if (maxValue === "$0" || maxValue === "$") maxValue = "";

    return (
      <StreamFilter
        hasSelectedValues={!!label}
        label={label || "Price"}
        onClear={this.handleOnClear}
        onClose={this.handleOnClose}>
        {({ apply }) => (
          <>
            <Label htmlFor="price-min">Price Range</Label>
            <Grid>
              <Cell>
                <Input
                  id="price-min"
                  name="min"
                  large
                  value={minValue}
                  placeholder="No min"
                  onChange={this.handleOnChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      apply();
                    }
                  }}
                />
              </Cell>
              <Cell>
                <Spacer>-</Spacer>
              </Cell>
              <Cell>
                <Input
                  name="max"
                  value={maxValue}
                  placeholder="No Max"
                  onChange={this.handleOnChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      apply();
                    }
                  }}
                />
              </Cell>
            </Grid>
          </>
        )}
      </StreamFilter>
    );
  }

  handleOnChange = (e) => {
    const prefixLength = 1;
    const previousValue = this.state[e.target.name];
    retainCaretPositionForCurrencyAndNumbers(
      e.target,
      prefixLength,
      previousValue
    );

    let formattedValue = formatNumber(e.target.value, "$0,0");
    if (formattedValue === "$0" || formattedValue === "$") formattedValue = "";
    if (formattedValue.startsWith("-"))
      formattedValue = formattedValue.substr(1);

    this.setState({ [e.target.name]: formattedValue });
  };

  handleOnClear = () => {
    this.setState({ min: "", max: "" });
  };

  handleOnClose = () => {
    const hasStateChanged = this.state.min !== null || this.state.max !== null;
    const stateEqualsProps =
      this.state.min === this.props.min && this.state.max === this.props.max;

    if (stateEqualsProps || !hasStateChanged) return;

    let price = {};

    if (this.state.min || this.state.max) {
      price = { ...price, field: "price" };
    }

    if (this.state.min) {
      price = { ...price, gte: String(formatNumber(this.state.min, "0")) };
    }

    if (this.state.max) {
      price = { ...price, lte: String(formatNumber(this.state.max, "0")) };
    }

    const newFilters = !!Object.values(price).length
      ? { ...this.props.filters, price }
      : this.props.filters;

    this.props.replaceStreamFilters(newFilters);
  };
}

StreamFilterPrice.propTypes = {
  filters: PropTypes.object.isRequired,
  min: PropTypes.string,
  max: PropTypes.string,
  replaceStreamFilters: PropTypes.func.isRequired
};

export default StreamFilterPrice;
